<template>
  <div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true">
    </VueLoadingOverlay>
    {{ message }}
  </div>
</template>

<script>
import { _setAuthData } from '@/services/auth.service'
import { UsersService } from '@/services/users.service'
import { CommonService } from '@/services/common.service'
export default {
  name: 'Login',
  data: () => {
    return {
      loading: true,
      token: '',
      redirect: '',
      message: ''
    }
  },
  async created () {
    const token = this.$route.query.token;
    const redirect = this.$route.query.redirect;
    const platform = this.$route.query.platform;
    localStorage.setItem('platform', platform);
    if (token && redirect) {
      try {
        const systemConfig = await CommonService.getConfigSystem()
        const user = await UsersService.getCurrent(
          this.$route.query.token,
          systemConfig.data
        )
        if (user.success && user.data) {
          _setAuthData({
            accessToken: `Bearer ${this.$route.query.token}`,
            userData: user.data
          })
          this.$router.push(this.$route.query.redirect)
        }
      } catch (e) {
        this.message = e.message
      }
    } else {
      this.message = 'Không có token hoặc redirect'
    }
  }
}
</script>
